import { render, staticRenderFns } from "./my_like_job.vue?vue&type=template&id=06b825dd&scoped=true&"
import script from "./my_like_job.vue?vue&type=script&lang=js&"
export * from "./my_like_job.vue?vue&type=script&lang=js&"
import style0 from "./my_like_job.vue?vue&type=style&index=0&id=06b825dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b825dd",
  null
  
)

export default component.exports